// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

function nextWeek() {
  let today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
}

class Recipient {
  constructor(name, phone, email) {
    this.Name = name;
    this.Phone = phone;
    this.Email = email;
  }
}
class Reminder {
  contructor(messageType, offset, message, recipients) {
    this.MessageType = messageType;
    this.Offset = offset;
    this.Message = message;
    this.Recipients = recipients || [];
  }
}

class Notification {
  constructor(name, delay, content, caretaker) {
    this.Name = name;
    this.Delay = delay;
    this.Content = content;
    this.Caretaker = caretaker;
  }
}

class NotificationProfile {
  constructor(id, category, enable, name, notifications) {
    this.ID = id;
    this.Category = category;
    this.Enable = enable;
    this.Name = name;
    this.Notifications = notifications;
  }
}

class Patient {
  constructor(id, name, phone, email, startDate, language, notificationProfile) {
    this.ID = id;
    this.Name = name;
    this.Phone = phone || "";
    this.Email = email;
    this.Language = language;
    this.StartDate = startDate || new Date() ;
    this.NotificationProfile = notificationProfile;
    this.AcceptNotification = false;
    this.Recipients = [];
    this.Reminders = [];
  }
}


class Schedule {
  constructor(patientID, cardID, startdate = new Date(), enddate = nextWeek()) {
    this.ID = undefined;
    this.PatientID = patientID;
    this.CardID = cardID;
    this.StartDate = startdate;
    this.EndDate = enddate;
    this.Dose = [];
  }
}

export {
  Recipient,
  Reminder,
  Notification,
  NotificationProfile,
  Patient,
  Schedule,
}
